import React, { Component } from "react";
import * as s from "./CopyLinkBanner.module.scss";
import { Icons } from "src/libs/assets";
import { P, Button } from "src/views/shared/components";
import { NavigationStore } from "src/stores";
import { inject, observer } from "mobx-react";
import { copyToClipboard } from "src/libs/utils";
import { tx } from "src/libs/i18n";

interface Props {
  navigationStore?: NavigationStore;
  internalUrl?: string;
}

interface State {
  url: string;
  copySuccess: boolean;
}

@inject("navigationStore")
@observer
export class CopyLinkBanner extends Component<Props, State> {
  constructor(props) {
    super(props);
    const { href } = this.props?.navigationStore?.location;
    this.state = { url: href, copySuccess: false };
  }

  render() {
    const { url, copySuccess } = this.state;
    const { internalUrl } = this.props;
    return (
      <div className={s.copyLinkContainer}>
        <div className={s.contentContainer}>
          <img src={Icons.link_small} alt="Copy link icon" className={s.copyLinkIcon} />
          <P small className={s.link}>
            {internalUrl ? internalUrl : url}
          </P>

          {copySuccess ? (
            <P className={s.copySuccess}>{tx("misc.done")}</P>
          ) : (
            <Button
              size="medium"
              color="red"
              className={s.copyLinkButton}
              onClick={() => {
                copyToClipboard(internalUrl ? internalUrl : url);
                this.setState({ copySuccess: true });
              }}
            >
              {tx("misc.copy")}
            </Button>
          )}
        </div>
      </div>
    );
  }
}
